<template>
    <div class="agreement">
        <div v-if="['1', '2'].includes(type)" class="content" v-html="detail.content"></div>
        <div v-if="type === '3'" class="about">
            <div class="logo">
                <img src="@/assets/vipCoach/v2/icon_logo@2x.png" />
                <h4>斑斑教练</h4>
            </div>
            <div class="wrap">
                <p>斑斑教练app是一款专为驾校教练量身打造，集沟通、管理、教学、招生为一体的学习管理教学软件。</p>
                <p>我们致力于帮助教练解决学员管理、学员情况分析、安排教学计划等方面的问题，最终达到提升教学效率和服务质量的目的。</p>
                <p>这里为教练提供了大量的招生素材与招生海报，协助教练完成招生。同时，斑斑教练为教练提供了招生名片，教练可以通过名片分享进行潜客收集与跟踪，实现自主招生的目的。</p>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'agreement',
    props: {
        // type = 1 注册协议, type = 2 隐私协议, type = 3 关于我们
        type: {
            type: String,
            default: ''
        }
    },
    data () {
        return {
            detail: {},
            title: ''
        }
    },
    methods: {
        goBack () {
            this.$router.back()
        },
        getDetail () {
            this.$api.getCoachAgreement({
                type: this.type
            }).then(res => {
                if (res.status) {
                    this.detail = res.result
                }
            })
        }
    },
    created () {
        if (this.type !== '3') {
            this.title = this.type === '1' ? '注册协议' : '隐私协议'
            this.getDetail()
        }
    }
}
</script>
<style lang="scss" scoped>
* {
    box-sizing: border-box;
}
.agreement{
    color:#333;
    line-height: 24px;
    background-color: #f5f5f5;
    .content {
        padding: 20px;
        font-size: 13px;
        white-space: pre-wrap;
        word-wrap: break-word;
    }
    .about {
        padding:30px 20px;
        .logo{
            text-align: center;
            img{
                width: 80px;
            }
            h4{
                margin-top: 10px;
            }
        }
        .wrap{
            margin-top: 20px;
        }
        p{
            margin-bottom: 10px;
            text-indent: 2em;
            font-size: 15px;
            line-height: 24px;
        }
    }
}
</style>
